import React from 'react'
import { Skeleton } from '@fs/zion-ui'
import { css } from '@emotion/core'

const expanderCss = css`
  display: flex;
  justify-content: space-between;
  p {
    width: 100%;
  }
`

const loaderTypes = {
  button: <Skeleton.Button maxWidth="75%" />,
  expander: (
    <div css={expanderCss} data-testid="skeleton-expander">
      <Skeleton.Paragraph maxWidth="75%" size="md" />
      <Skeleton.Image height={20} width={20} />
    </div>
  ),
  heading: <Skeleton.H5 subheadingLineCount={1} />,
  body: <Skeleton.Paragraph size="md" />,
}

export default function LoadingWrapper({ loading, children }) {
  return (
    <>
      {loading &&
        React.Children.map(children, (child) => {
          if (child == null) return null
          if (child?.props?.skeletontype) return loaderTypes[child.props.skeletontype]
          return (
            <>
              <Skeleton.Paragraph maxWidth="50%" size="xs" />
              <Skeleton.Paragraph size="sm" />
            </>
          )
        })}
      {!loading && children}
    </>
  )
}
